import React, { useRef } from 'react'
import { Flex } from '../../Components/Common/Flex'
import { Button } from '../../Components/Common/Button'
import { FloatInput } from '../../Components/Common/FloatInput'
import { Text } from '../../Components/Common/Text'
import { FC } from '../../Services'

export const UploadDoc = ({ onUpload, name: [name, setName] }) => {
  const refFile = useRef(null)

  const uploadFile = async (e) => {
    const readFile = (file) =>
      new Promise((resolve, reject) => {
        const reader = new window.FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    e.stopPropagation()
    e.preventDefault()
    e.persist()
    if (!e.target.files.length) return false
    const uri = await readFile(e.target.files[0])
    const res = await FC.service('upload').create({ uri })
    onUpload({ id: res.id, documentUrl: res.documentUrl, name })
  }

  return (
    <Flex fw>
      <Text value='Carica nuovo documento' title bold size={20} />
      <input type='file' style={{ display: 'none' }} ref={refFile} onChange={uploadFile} />
      <FloatInput value={[name, setName]} label='Nome' id='name' style={{ width: 350, marginTop: 20 }} />
      <Button label='Carica' onClick={() => refFile.current.click()} style={{ marginTop: 20 }} disabled={!name} />
    </Flex>
  )
}
